import { NotesConfigurationSettings } from "./NotesConfigurationSettings";

class NotesFilterSettings {
    public NotesConfigurationSettings: NotesConfigurationSettings;

    constructor() {
        this.NotesConfigurationSettings = new NotesConfigurationSettings();
    }
}

export { NotesFilterSettings };
